import { Pipe, PipeTransform } from '@angular/core';
import { UiTDatabankLanguages } from '@internal-models/uit-database.model';

@Pipe({ name: 'organizerName' })
export class OrganizerNamePipe implements PipeTransform {
	transform(value: string | { [language in UiTDatabankLanguages]?: string }): string {
		if (typeof value === 'string') {
			return value;
		}
		return value.nl ?? value.en ?? value.fr ?? value.de;
	}
}
